import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { analyticsTrack } from '../../../analyticsUtils';
import googleSignIn from '../../../../assets/images/google-sign-up-logo.svg';
import msSignIn from '../../../../assets/images/ms-sign-up-logo.svg';

const redirectSocialLogin = (link, button, location) => {
  analyticsTrack(`Clicked sign up with ${button}`, { location });
  window.open(link);
};

function SocialLoginForm({
  state,
  googleOmniauthUrl,
  msOmniauthUrl,
  location,
}) {
  return (
    <Fragment>
      <div className="sign-in-divider">
        <hr />
        <div className="or-text">or</div>
        <hr />
      </div>
      <div className="sign-in-provider">
        { googleOmniauthUrl
        && (
        <a
          className="google-sign-in mt-3"
          onClick={() => redirectSocialLogin(`${googleOmniauthUrl}?prompt=select_account&state=${state}`, 'google', location)}
          role="button"
          tabIndex={0}
        >
          <img src={googleSignIn} alt="Sign up with Google" />
          <div className="sign-in-text">
            Sign up with Google
          </div>
        </a>
        )}
        { msOmniauthUrl
        && (
        <a
          className="ms-sign-in mt-3"
          onClick={() => redirectSocialLogin(`${msOmniauthUrl}?state=${state}`, 'microsoft', location)}
          role="button"
          tabIndex={0}
        >
          <img src={msSignIn} alt="Sign up with Microsoft" />
          <div className="sign-in-text">
            Sign up with Microsoft
          </div>
        </a>
        )}
      </div>
    </Fragment>
  );
}

SocialLoginForm.propTypes = {
  googleOmniauthUrl: PropTypes.string,
  msOmniauthUrl: PropTypes.string,
  state: PropTypes.string,
  location: PropTypes.string.isRequired,
};

SocialLoginForm.defaultProps = {
  googleOmniauthUrl: null,
  msOmniauthUrl: null,
  state: 'register_employer',
};

export default SocialLoginForm;
